module.exports = " <div class=vc-page> <header-bar> <icon-button slot=left @click=back() icon=arrow_back></icon-button> <span>Circular</span> </header-bar> <scroll-view> <div class=vc-content-block> <circular style=\"margin-left: 16px\"></circular> <circular style=\"margin-left: 16px\" color=green :size=36></circular> <circular style=\"margin-left: 16px\" color=amber :size=48></circular> </div> </scroll-view> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src-examples/views/circular.vue
 ** module id = 388
 ** module chunks = 1
 **/